export function initUserCreditsDetails() {
	const USER_CREDITS_SELECTOR = '.pro-page-credits-user';
	const userCreditsElements = document.querySelectorAll(USER_CREDITS_SELECTOR);
	if (!userCreditsElements.length) return;

	document.addEventListener('click', (event) => {
		const targetElement = event.target.closest(USER_CREDITS_SELECTOR);
		if (!targetElement) {
			userCreditsElements.forEach((element) => element.classList.remove('active'));
			return;
		}

		userCreditsElements.forEach((element) => {
			if (element !== targetElement) {
				element.classList.remove('active');
			}
		});

		targetElement.classList.toggle('active');
	}, { passive: true });
}


